var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex "},[_c('input',{staticClass:" tw-hidden",attrs:{"type":"checkbox","name":"Checkbox","id":"Checkbox"},domProps:{"checked":_vm.value},on:{"change":_vm.handleInput}}),_c('label',{staticClass:" tw-flex tw-group",class:{
      'tw-cursor-pointer': !_vm.disabled,
      'tw-pointer-events-none': _vm.disabled
    },attrs:{"for":"Checkbox"}},[_c('div',{staticClass:" tw-h-5 tw-w-5 tw-border tw-border-solid tw-rounded-md tw-mr-2 tw-border-black-100 group-hover:tw-border-primary",class:{
        ' tw-bg-primary-100 tw-border-primary': _vm.value && !_vm.disabled
      }},[(_vm.value)?_c('icon-done',{staticClass:" tw-h-4.5 tw-w-4.5",class:{
          ' tw-fill-black-400': !_vm.disabled,
          'tw-fill-black-100': _vm.disabled
        }}):_vm._e()],1),_c('div',{staticClass:" tw-font-semibold tw-text-sm tw-w-full",class:{
        'tw-text-black': !_vm.disabled,
        'tw-text-black-100': _vm.disabled
      }},[_vm._v(" "+_vm._s(_vm.label)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }